import { provideRouter, Routes, withInMemoryScrolling } from '@angular/router';
import {
  APP_ID,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SsWebSocketsModule } from './core/vendor/ss-web-sockets/ss-web-sockets.module';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import {
  BrowserModule,
  HammerModule,
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { GlobalErrorHandler } from './core/helpers/global-error-handler';
import { CacheControlInterceptor } from './core/interceptors/cache-control.interceptor';
import { HostRequestsInterceptor } from './core/interceptors/host-requests.interceptor';
import { DecimalPipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideABTest } from './core/ab-test/ab-test';
import { abTestList } from './core/ab-test/ab-test.data';
import { provideStoreInitializer } from 'ngx-unificator/store';
import { GlobalStore } from './core/store';
import { provideInitializer } from './core/initializer/initializer-queue';
import { provideBrandConfig } from './core/services/brand-config/brand-config.provider';
import { provideBotRules } from './core/providers/bot-rules.provider';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', loadChildren: () => import('./page/page.module').then(m => m.PageModule) },
    ],
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideStoreInitializer(GlobalStore),
    provideClientHydration(withIncrementalHydration(), withEventReplay()),
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideInitializer(),
    provideBotRules(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideBrandConfig(),
    provideABTest(abTestList),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
    ),
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      BrowserAnimationsModule,
      ReactiveFormsModule,
      SsWebSocketsModule,
      NgxMaskDirective,
      HammerModule,
    ),
    DecimalPipe,
    provideNgxMask(),
    { provide: APP_ID, useValue: 'ss' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HostRequestsInterceptor,
      multi: true,
    },
  ],
};
